import { useEffect, useRef, useState } from "react";

export default function useScrollHandler() {
    const parentRef = useRef(null);
    const childRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 });
    const [isScrolling, setIsScrolling] = useState(false);

    let scrollTimeout;
    const handleScroll = () => {
        const position = { x: window.scrollX, y: window.scrollY };
        setScrollPosition(position);

        setIsScrolling(true);
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            setIsScrolling(false);
        }, 300);
    };

    const handleScrollDirection = (
        direction = "up",
        ref = null,
        scrollAmount = 100,
    ) => {
        if (!ref || !ref.current) {
            console.error("Reference is null or invalid");

            return;
        }

        setIsScrolling(true);

        let scrollOptions = {
            behavior: "smooth",
        };

        switch (direction) {
            case "up":
                scrollOptions.top = -scrollAmount;
                break;
            case "down":
                scrollOptions.top = scrollAmount;
                break;
            case "left":
                scrollOptions.left = -scrollAmount;
                break;
            case "right":
                scrollOptions.left = scrollAmount;
                break;
            default:
                console.log("THERE IS NO DIRECTION SELECT !");
                return;
        }

        ref.current.scrollBy(scrollOptions);
    };

    const isOverflowing = (isVertical = false) => {
        const parent = parentRef.current;
        const child = childRef.current;

        if (parent && child) {
            const parentRect = parent.getBoundingClientRect();
            const childRect = child.getBoundingClientRect();

            const isOverflowingHorizontally =
                childRect.right > parentRect.right ||
                childRect.left < parentRect.left;
            const isOverflowingVertically =
                childRect.bottom > parentRect.bottom ||
                childRect.top < parentRect.top;

            if (isVertical) {
                return isOverflowingVertically;
            }

            return isOverflowingHorizontally;
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return {
        ...scrollPosition,
        isScrolling,
        handleScrollDirection,
        parentRef,
        childRef,
        isOverflowing,
    };
}
